import { useEffect, useState } from "react";
import { Card, Table, Tooltip } from "antd";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getPayslipPagination } from "hooks/api/payrollApi/payslipApi";
import { PAYROLL_PAY_SLIP } from "constants";
import { ImagePaths } from "utils/ImagePath";
import IconButton from "components/ui/Button/IconButton";
import { EmployeeDetails } from "components/common/CommonComponent";
import { toIndianCurrency } from "utils/StringUtils";
import { downloadPDF } from "components/common/CommonFuntion";
import moment from "moment";
import { NEW_EMPLOYEE_PAY_SLIP } from "constant";
import useApiMethods from "hooks/apiConfig/method/apiMethods";

function PaySlipUser() {
    const pageSize = 10;
    const authtoken = sessionStorage.getItem("token");
    const [pageNo, setPageNo] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [sorting, setSorting] = useState("");
    const [dataUpdated, setDataUpdated] = useState(false);
    const [filterVisible, setFilterVisible] = useState(false);
    const [reorderedColumns, setReorderedColumns] = useState([]);
    const tableContainerHeight = "70vh";

    useEffect(() => {
        if (!authtoken) {
            window.location.href = "/";
        }
    }, [authtoken]);

    // const [data, pageInfo, loading, _message, refetch] = useApiData(getPayslipPagination, {
    //     pageNo,
    //     pageSize,
    //     searchText,
    //     sorting,
    // });

    // useEffect(() => {
    //     if (_message && _message.isErrorMsg && _message.errorMsgText) {
    //         ToastMsg('error', _message.errorMsgText);
    //     }
    // }, [_message.errorMsgText]);

    const { fetch } = useApiMethods();
    const [data, setData] = useState([]);
    const [pageInfo, setPageInfo] = useState([])
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({ pageNo: '', pageSize: '', query: "is_personal=" + true, search: '', sorting: '' })

    const fetchNoticeData = async () => {
        const res = await fetch(
            NEW_EMPLOYEE_PAY_SLIP,
            filter,
            setLoading
        );
        if (res) {
            if (res.status) {
                setData(res.data.result);
                setPageInfo({
                    pageNo: res.data.page_no,
                    pageSize: res.data.page_size,
                    totalCount: res.data.total_count,
                    noOfPages: res.data.no_of_pages,
                });
            }
        }
    };

    useEffect(() => {
        if (!authtoken) {
            window.location.href = "/";
        }
        fetchNoticeData();
    }, [filter]);

    const generateQuery = (pageNo, pageSize, searchText, sorting) => {
        return `?page_no=${pageNo}&page_size=${pageSize}&search=${searchText || ""}${sorting ? `&${sorting}` : ""}`;
    };

    const handleSearch = () => {
        const query = generateQuery(1, pageSize, searchText, sorting);
        setPageNo(1);
        setFilter((prev) => ({
            ...prev,
            pageNo: 1,
            pageSize,
            search: searchText,
            sorting,
            query,
        }));
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const sortOrder = sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : "";
        const sortQuery = sorter.order ? `sort=${sortOrder}&column=${sorter.columnKey}` : "";
        const query = generateQuery(pagination.current, pageSize, searchText, sortQuery);
        setFilter((prev) => ({
            ...prev,
            pageNo: pagination.current,
            pageSize,
            search: searchText,
            sorting: sortQuery,
            query,
        }));
        setSorting(sortQuery);
    };

    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            width: "10dvw",
            sorter: true,
            fixed: "left",
            render: (_, record) => {
                return (
                    <span style={{ cursor: "pointer" }}>
                        {record?.published_date ? moment(record.published_date).format("DD-MM-YYYY") : "-"}
                    </span>
                )
            }
        },
        {
            title: "CTC",
            dataIndex: "ctc",
            key: "ctc",
            sorter: true,
            width: "10dvw",
            render: (_, record) =>
                record?.ctc?.length > 7 ? (
                    <Tooltip title={record?.ctc}>
                        {
                            <span>{record?.ctc?.slice(0, 20) + "..."}</span>
                        }
                    </Tooltip>
                ) : (
                    <p>{record?.ctc ? toIndianCurrency(record?.ctc) : "-"}</p>
                ),
            align: "right",
        },
        {
            title: "Earning",
            dataIndex: "earning",
            key: "earning",
            sorter: true,
            width: "10dvw",
            render: (_, record) => record?.earnings?.length > 7 ? (
                <Tooltip title={record?.earnings}>
                    {
                        <span>{record?.earnings?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.earnings ? toIndianCurrency(record?.earnings) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "Deductions",
            dataIndex: "deductions",
            key: "deductions",
            sorter: true,
            width: "10dvw",
            render: (_, record) => record?.deductions?.length > 7 ? (
                <Tooltip title={record?.deductions}>
                    {
                        <span>{record?.deductions?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.deductions ? toIndianCurrency(record?.deductions) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "Net Pay",
            dataIndex: "net_pay",
            key: "net_pay",
            sorter: true,
            width: "10dvw",
            render: (_, record) => record?.net_pay?.length > 7 ? (
                <Tooltip title={record?.net_pay}>
                    {
                        <span>{record?.net_pay?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.net_pay ? toIndianCurrency(record?.net_pay) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "LOP",
            dataIndex: "lop",
            key: "lop",
            sorter: true,
            width: "10dvw",
            render: (_, record) => record?.lop_amount?.length > 7 ? (
                <Tooltip title={record?.lop_amount}>
                    {
                        <span>{record?.lop_amount?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.lop_amount ? toIndianCurrency(record?.lop_amount) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "Reimbursements",
            dataIndex: "reimbursements",
            key: "reimbursements_total",
            width: "10dvw",
            sorter: true,
            render: (_, record) => record?.reimbursements_total?.length > 7 ? (
                <Tooltip title={record?.reimbursements_total}>
                    {
                        <span>{record?.reimbursements_total?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.reimbursements_total ? toIndianCurrency(record?.reimbursements_total) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "Credit",
            dataIndex: "credits",
            key: "credits",
            width: "10dvw",
            sorter: true,
            render: (_, record) => record?.credits?.length > 7 ? (
                <Tooltip title={record?.credits}>
                    {
                        <span>{record?.credits?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.credits ? toIndianCurrency(record?.credits) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "Debit",
            dataIndex: "debit",
            key: "debit",
            width: "10dvw",
            sorter: true,
            render: (_, record) => record?.debit?.length > 7 ? (
                <Tooltip title={record?.debit}>
                    {
                        <span>{record?.debit?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.debit ? toIndianCurrency(record?.debit) : "-"}</p>
            ),
            align: "right",
        },
        {
            title: "Paid Salary",
            dataIndex: "paid_salary",
            key: "paid_salary",
            width: "10dvw",
            sorter: true,
            render: (_, record) => record?.paid_salary?.length > 7 ? (
                <Tooltip title={record?.paid_salary}>
                    {
                        <span>{record?.paid_salary?.slice(0, 20) + "..."}</span>
                    }
                </Tooltip>
            ) : (
                <p>{record?.paid_salary ? toIndianCurrency(record?.paid_salary) : "-"}</p>
            ),
            align: "right",
            fixed: "right",
        },
        {
            title: "Action",
            key: "action",
            width: "10dvw",
            render: (_, record) => (
                <IconButton
                    title="Download"
                    icon={<img src={ImagePaths.downloadPdf.default} alt="download pdf" />}
                    onClick={() => record.payslip ? downloadPDF(record.payslip) : {}}
                />
            ),
            align: "center",
            fixed: "right",
        },

    ];

    const handleStateChanges = (search = "", reorderedList = []) => {
        setSearchText(search)
        setReorderedColumns(reorderedList)
    }

    const printData =
        "?page_no=" + pageNo +
        "&page_size=" + pageSize +
        "&myself=" + true +
        "&search=" + searchText + (sorting ? `&${sorting}` : "");

    const styles = {
        fltContainer: {
            border: "1px solid #cbcbcb",
            height: tableContainerHeight,
            borderRadius: '5px'
        },
    }

    return (
        <Card className="h-full overflow-hidden">
            <div className={"h-1/6"} >
                <CommonTblHeader pageName={"Payslip"}
                    pageInfo={pageInfo}
                    handleSearch={handleSearch} url={NEW_EMPLOYEE_PAY_SLIP} query={printData}
                    onStateChange={handleStateChanges} columns={columns}
                    isAddRequired={false} isDraftRequired={false} isFltRequired={false} isPrintRequired={data?.length > 0 ? true : false} isExcelRequired={data?.length > 0 ? true : false}
                />
            </div>
            <div className="h-[80%] flex justify-center items-center  mt-1">
                <div className={"mt-5 w-full custom-table"} style={styles.fltContainer}>
                    <Table
                        columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
                        dataSource={data?.length > 0 ? data : null}
                        loading={loading}
                        style={{ "--table-container-height": tableContainerHeight }}
                        scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
                        onChange={handleTableChange}
                        pagination={{
                            style: { marginRight: 20, padding: 0 },
                            defaultPageSize: pageSize,
                            showSizeChanger: false,
                            showQuickJumper: true,
                            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
                            pageSizeOptions: ["10", "20", "30"],
                            pageSize,
                            defaultCurrent: pageNo,
                        }}
                        key={dataUpdated ? "updated" : "not-updated"}
                        bordered
                    />
                </div>
            </div>
        </Card>
    );
}

export default PaySlipUser;